import { OpenInNewOutlined } from '@mui/icons-material';
import { IconButton, Typography, TextField, Stack } from '@mui/material';

import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as SearchOutlined } from 'common/assets/images/search-outline.svg';
import CommonTable from 'common/components/Table/CommonTable';
import { Column } from 'common/components/Table/CommonTableStyles';
import { toSentenceCase } from 'common/utils/utilFunctions';

import { RootState } from '../../../common/store/AppStore';
import {
	setPagination,
	setRowsPerPagination,
} from '../../../common/store/reducer/commonReducer';
import { setExecutedList } from '../../../common/store/reducer/jobListReducer';

import { getExecutedDetails } from './api';

import styles from './JobScheduler.module.scss';

const ExecutedList = () => {
	const dispatch = useDispatch();

	const [searchText, setSearchText] = useState('');

	const executedJobs: any = useSelector(
		(state: RootState) => state.jobsList.executedJobs,
	);

	useEffect(() => {
		const getScheduledList = async () => {
			const resp = await getExecutedDetails();

			dispatch(setExecutedList(resp));
			const paginationObj = {
				pageSize: 10,
				pageNumber: 0,
			};

			dispatch(setPagination(paginationObj));
			const rowsPerPageObj = {
				rowsPerPage: 10,
			};
			dispatch(setRowsPerPagination(rowsPerPageObj));
		};
		getScheduledList();
	}, []);

	useEffect(() => {}, [searchText]);

	const columns: readonly Column[] = [
		{
			id: 'id',
			label: 'id',
			disablePadding: false,
			isSortable: false,
		},
		{
			id: 'jobName',
			label: 'job Name',
			disablePadding: false,
			isSortable: false,
			render: (params: any) => <Typography>{params.jobName}</Typography>,
		},
		{
			id: 'instancesCount',
			label: 'Instances Count',
			disablePadding: false,
			isSortable: false,
			render: (params: any) => <Typography>{params.instancesCount}</Typography>,
		},
		{
			id: 'type',
			label: 'Type',
			disablePadding: false,
			isSortable: false,
			render: (params: any) => <Typography>{params.type}</Typography>,
		},
		{
			id: 'details',
			label: 'Details',
			disablePadding: false,
			isSortable: false,
			render: () => (
				<Typography>
					<span className={styles['field-color']}>
						{toSentenceCase('View Details')}{' '}
						<OpenInNewOutlined color="primary" />
					</span>
				</Typography>
			),
		},
	];

	const onCheckBoxSelected = () => {};

	return (
		<Stack spacing={2}>
			<TextField
				variant="outlined"
				placeholder={toSentenceCase('Search Job name or Job ID')}
				InputProps={{
					startAdornment: (
						<IconButton>
							<SearchOutlined className={styles['input-search-icon']} />
						</IconButton>
					),
				}}
				size="small"
				className={styles['searchbar-textfield']}
				onChange={(e) => setSearchText(e.target.value)}
			/>
			<CommonTable
				rows={executedJobs}
				columns={columns}
				defaultSortKey=""
				isCheckBoxEnabled
				onRowSelectable={onCheckBoxSelected}
				tableStyles={{ minWidth: 750, maxHeight: 440 }}
			/>
		</Stack>
	);
};

export default ExecutedList;
